import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HwtButton } from '../Buttons/HwtButton';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import WebLink from '../WebLink';
import { getNewLink } from 'util/workbook-util';
import { useSelector } from 'react-redux';
import { AppStoreState } from 'types';
import { translate } from 'translations/translator';

export const NoClassroomsToAssignModal = ({ gradeLevel, user }) => {
  const classes = useStyles();
  const [, { closeModal }] = useModal();
  const currentWorkbook: any = useSelector(({ app }: AppStoreState) => app.currentWorkbook);
  const license = user.licenses.find(
    x => x.productCurriculumId === currentWorkbook.products[0].productCurriculumId
  );
  const t = (key, options?) => translate('lessonAssignment', key, { ...options });

  return (
    <Box className={classes.container}>
      {license.trial && (
        <Box>
          <Typography style={{ textAlign: 'center' }} variant="h6">
            {t('noClassesToAssignTrialHeader')}
          </Typography>
          <br />
          <Typography variant="body2"> {t('noClassesToAssignTrialUser')}</Typography>
        </Box>
      )}

      {!license.trial && !user?.me?.managedUser && (
        <Box>
          <Typography variant="h6">{t('noClassesToAssignHeader')}</Typography>
          <br />
          <Typography variant="body1">
            <WebLink to={getNewLink('', '', 'pli')} target={'_blank'}>
              {t('noClassesToAssignPLI1')}
            </WebLink>
            {t('noClassesToAssignPLI2', { gradeLevel: gradeLevel })}
          </Typography>
        </Box>
      )}
      {!license.trial && user?.me?.managedUser && (
        <Box>
          <Typography variant="h6">{t('noClassesToAssignHeader')}</Typography>
          <Typography variant="body1">{t('noClassesToAssignManagedUser')}</Typography>
        </Box>
      )}
      <Box className={classes.actionItem}>
        <HwtButton variant="contained" onClick={closeModal}>
          OK
        </HwtButton>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex !important',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '254px',
    width: '616px',
    backgroundColor: '#fff',
    padding: '10px 24px'
  },
  actionItem: {
    alignSelf: 'flex-end'
  }
}));
